function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest(); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
export var languages = {
  nl: 31,
  en: -1,
  fr: -2,
  de: -3
};
export var availableErps = ['nl', 'be', 'de', 'uk', 'lu', 'ch', 'fr'];
export var languageToCode = function languageToCode(locale) {
  return languages[locale] || -1;
};
export var getWindowLocation = function getWindowLocation() {
  var _window$location$host = window.location.hostname.split('.').slice(-1),
    _window$location$host2 = _slicedToArray(_window$location$host, 1),
    erpSystem = _window$location$host2[0];
  var _window$location$path = window.location.pathname.split('/'),
    _window$location$path2 = _slicedToArray(_window$location$path, 2),
    language = _window$location$path2[1];
  return {
    erpSystem: availableErps.findIndex(function (erp) {
      return erp === erpSystem;
    }) > -1 ? erpSystem : 'nl',
    language: languages[language] ? language : 'nl'
  };
};
export var updateLanguageURL = function updateLanguageURL() {
  var lang = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'nl';
  var pathname = window.location.pathname;
  var newPath;
  var queryParams = new URLSearchParams(window.location.search).toString();
  var _pathname$split = pathname.split('/'),
    _pathname$split2 = _toArray(_pathname$split),
    rest = _pathname$split2.slice(2);
  newPath = "/".concat(lang).concat(rest.length ? "/".concat(rest.join('/')) : '');
  newPath += queryParams ? "?".concat(queryParams) : '';
  window.history.replaceState({}, '', newPath);
};

/**
 * Both arguments and the import path can be customized
 * NOTE: `@babel/plugin-syntax-dynamic-import` is a necessary dependency
 */
export var fetchTranslations = function fetchTranslations(_ref) {
  var _ref$appId = _ref.appId,
    appId = _ref$appId === void 0 ? 'atomicUI' : _ref$appId,
    _ref$language = _ref.language,
    language = _ref$language === void 0 ? 'nl' : _ref$language,
    _ref$filePath = _ref.filePath,
    filePath = _ref$filePath === void 0 ? './' : _ref$filePath;
  return import("".concat(filePath).concat(appId, "-").concat(language)).then(function (module) {
    return module["default"];
  });
};